import { createAsyncThunk } from '@reduxjs/toolkit';
import { channelService } from '../../services';

const getChannels = createAsyncThunk(
    'channel/getChannels',
    async (payload, thunkAPI) => {
        try {
            const response = await channelService.getChannels(payload.companyId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
  );

  const addOrRemoveSelectedChannel = createAsyncThunk(
    'channel/addOrRemoveSelectedChannel',
    async (payload, thunkAPI) => {
        try {
            const response = await channelService.addOrRemoveSelectedChannel(payload.companyId, payload.channelId, payload.addRemove);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
  );

export {
    getChannels,
    addOrRemoveSelectedChannel
};
